module.exports = __webpack_public_path__ + "img/apple_appstore_black.b37fbda5.svg";